<div id="login" fxLayout="column">
  <div id="login-form-wrapper" fxLayout="column" fxLayoutAlign="center center">
    <div
      id="login-form"
      [class.mat-elevation-z2]="!isActive"
      [class.mat-elevation-z8]="isActive"
    >
      <div class="logo">
        <img
          src="../../assets/heartcare_logo.png"
          style="height: 100px; width: 100px"
        />
      </div>

      <div class="mat-display-2 title">HeartCare</div>

      <form name="loginForm" [formGroup]="loginForm">
        <mat-form-field appearance="fill">
          <mat-label>User ID</mat-label>
          <input
            matInput
            required
            formControlName="userid"
            [(ngModel)]="userid"
          />
          <mat-error *ngIf="loginForm.hasError('required', ['userid'])">User ID is required.</mat-error> 
          <mat-error *ngIf="loginForm.hasError('minlength', ['userid'])">Please enter valid User ID.</mat-error>
        </mat-form-field>

        <mat-form-field class="mt-10" appearance="fill">
          <mat-label>Password</mat-label>
          <input
            matInput
            formControlName="password"
            [(ngModel)]="password"
            type="password"
            required
            maxlength="15"
          />
          <mat-error *ngIf="loginForm.hasError('required', ['password'])"
            >Password is required</mat-error
          >
          <mat-error
            *ngIf="
              loginForm.hasError('pattern', ['password']) ||
              loginForm.hasError('minlength', ['password'])
            "
          >Password must have 8-15 characters, with at least one special,
          uppercase, and lowercase character</mat-error
          >
          <mat-error *ngIf="loginForm.hasError('authFailed', ['password'])">
            Incorrect User ID or Password</mat-error
          >
        </mat-form-field>

        <button
          [disabled]="loginForm.invalid"
          mat-raised-button
          color="accent"
          class="submit-button mat-body-2"
          aria-label="LOG IN"
          (click)="login()"
        >
          LOGIN
        </button>
        <div
          class="remember-forgot-password"
          fxLayout="row"
          fxLayout.xs="column"
          fxLayoutAlign="center"
        >
          <a
            class="forgot-password mat-body-2"
            routerLink="/forgot-password"
            style="text-align: center"
          >
            Forgot Password?
          </a>
        </div>
      </form>
    </div>
  </div>
</div>